import React, { useMemo, useRef, useState, useLayoutEffect } from 'react';
import {
	Autocomplete,
	Checkbox,
	Chip,
	FormControl,
	FormLabel,
	TextField,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { formatKey } from '@/utils/constants';
import { AUDIT_ACTION_TYPES } from '@/features/audit/auditApi';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;
const actionTypeOptions = AUDIT_ACTION_TYPES.map((value) => ({
	value,
	label: formatKey(value),
}));

const CHIP_WIDTH = 120;
const RESERVED_SPACE = 48;
export const AuditActivityTypeSelect = ({
	value = [],
	onChange,
	disabled = false,
	noLabel = false,
}) => {
	const containerRef = useRef();
	const [limitTags, setLimitTags] = useState(-1);
	const selectedOptions = useMemo(
		() => actionTypeOptions.filter((option) => value.includes(option.value)),
		[value],
	);
	useLayoutEffect(() => {
		if (!containerRef.current) return;
		const available = containerRef.current.offsetWidth - RESERVED_SPACE;
		const maxChips = Math.floor(available / CHIP_WIDTH);
		setLimitTags(maxChips > 0 ? maxChips : 1);
	}, [selectedOptions]);
	return (
		<FormControl fullWidth size='small'>
			{!noLabel && <FormLabel>Activity type</FormLabel>}
			<Autocomplete
				ref={containerRef}
				multiple
				limitTags={limitTags}
				disabled={disabled}
				options={actionTypeOptions}
				value={selectedOptions}
				disableCloseOnSelect
				getOptionLabel={(option) => option.label}
				isOptionEqualToValue={(option, optionValue) => option.value === optionValue.value}
				onChange={(_event, newValue) => onChange(newValue.map((item) => item.value))}
				renderOption={(props, option, { selected }) => {
					const { key, ...optionProps } = props;
					return (
						<li key={key} {...optionProps}>
							<Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								style={{ marginRight: 8 }}
								checked={selected}
							/>
							{option.label}
						</li>
					);
				}}
				renderValue={(selected, getItemProps) =>
					selected.map((option, index) => {
						const { key, ...itemProps } = getItemProps({ index });
						return <Chip size='small' label={option.label} key={key} {...itemProps} />;
					})
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='All activity types'
						size='small'
						sx={{
							cursor: 'pointer',
							...(selectedOptions.length > 0 && {
								'& input': { display: 'none' },
							}),
						}}
					/>
				)}
				sx={{
					cursor: 'pointer',
					'& .MuiInputBase-root': {
						cursor: 'pointer',
						py: 0,
						flexWrap: 'nowrap',
						overflow: 'hidden',
					},
					'& .MuiAutocomplete-tag': {
						maxWidth: '100%',
					},
					'& input': {
						cursor: 'pointer',
					},
				}}
			/>
		</FormControl>
	);
};